module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trainer-manager__content"
  }, [_c('v-form', {
    attrs: {
      "handle-submit": _vm.handleSubmitUpdatePassword
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "newPassword",
      "type": "password",
      "data-vv-value-path": "input",
      "data-vv-name": "newPassword",
      "data-vv-as": "new password",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('newPassword') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('newPassword') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleSubmit($event)
      }
    },
    model: {
      value: (_vm.updatePassword.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.updatePassword, "newPassword", $$v)
      },
      expression: "updatePassword.newPassword"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n        New password: *\n      ")])], 2), _vm._v(" "), _c('v-button', {
    attrs: {
      "block": true,
      "disabled": _vm.loadingUpdatePassword
    },
    on: {
      "click": _vm.handleSubmitUpdatePassword
    }
  }, [_vm._v("\n      " + _vm._s(_vm.loadingUpdatePassword ? 'Loading...' : 'Save') + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71ec6777"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TrainerManager/UpdatePassword.vue
// module id = 1701
// module chunks = 1